import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  convertAmount,
  parseNumberByPrecision,
  tableBetHistoryStore,
  useTranslation,
} from '@pascal/pascal-core';

import '../SelectedHistory.scss';
import { globalTranslationKeys } from '../../../enums/translationKeys';

import { parseOddByPrecision } from '../../../helpers/parseOddByPrecision';
import { FishTable } from '../../../components/fishTable';

export const SelectedRow = observer(() => {
  const { thirdStep } = tableBetHistoryStore;
  const { data: thirdStepData } = thirdStep;
  const { roundData, odd } = thirdStepData;
  const t = useTranslation();

  const roundTotalOdd = useMemo(() => {
    const totalOdd = +roundData?.[0].odd
      ? roundData
          ?.filter((item) => item.odd)
          .reduce((acm, current) => parseNumberByPrecision(acm, current.odd, 2, true), 1)
      : 0;
    return parseOddByPrecision(totalOdd, 2);
  }, [roundData]);

  return (
    <div className='crazy-worm-history-el'>
      <div className='resultTitleContainer'>
        <p className='resultTitle1'>{t(globalTranslationKeys.Result)}</p>
        <p className='resultTitle2'>
          {t(globalTranslationKeys.Odd)} x{/* eslint-disable-next-line no-nested-ternary */}
          {odd || odd === 0 ? odd : roundData ? roundTotalOdd : '--'}
        </p>
      </div>
      <FishTable data={thirdStepData} />
      <div className='tb-game-history-bet-info-wrp'>
        <div className='tb-game-history-bet-info-header'>
          <div className='tb-game-history-bet-info-h-cl'>
            <p className='tb-history-cl-header-txt'>{t(globalTranslationKeys.BetAmount)}</p>
          </div>
          <div className='tb-game-history-bet-info-h-cl'>
            <p className='tb-history-cl-header-txt'>{t(globalTranslationKeys.Odd)}</p>
          </div>
          <div className='tb-game-history-bet-info-h-cl'>
            <p className='tb-history-cl-header-txt'>{t(globalTranslationKeys.Win)}</p>
          </div>
        </div>
        <div className='tb-game-history-bet-info-main'>
          <div className='tb-game-history-bet-info-main-row'>
            <div className='tb-his-bet-info-main-row-ins-cl bet'>
              <p className='tb-his-bet-info-main-txt'>{`${
                thirdStepData.freeBetId ? `${t(globalTranslationKeys.FreeBet)}:` : ''
              } ${convertAmount(thirdStepData.amount)}`}</p>
            </div>
            <div className='tb-his-bet-info-main-row-ins-cl'>
              <p className='tb-his-bet-info-main-txt'>{thirdStepData.odd}</p>
            </div>
            <div className='tb-his-bet-info-main-row-ins-cl bet'>
              <strong className='tb-his-bet-info-main-txt win'>
                {convertAmount(thirdStepData.winAmount)}
              </strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
